<app-page-content
  header="Services"
  subtitle="Well-built software, tailored to fit your business."
>
  <div class="service-section">
    <div id="business-websites" class="scroll-anchor"></div>
    <app-service-card
      header="Business websites"
      subtitle="A fast, polished site that makes the right impression — and holds up long after launch."
    >
      <img ngSrc="services/business-websites.svg" height="166" width="217" priority>
    </app-service-card>
  </div>

  <div class="service-section">
    <div id="integrations-and-automation" class="scroll-anchor"></div>
    <app-service-card
      header="Integrations and automation"
      subtitle="We connect your tools and automate the tasks that slow your team down."
      layout="row-reverse"
    >
      <img ngSrc="services/integrations-and-automation.svg" height="148" width="312" priority />
    </app-service-card>
  </div>

  <div class="service-section">
    <div id="custom-applications" class="scroll-anchor"></div>
    <app-service-card
      header="Custom applications"
      subtitle="Purpose-built tools and dashboards designed around how your team actually works."
    >
      <img ngSrc="services/custom-web-applications.svg" height="157" width="203" priority />
    </app-service-card>
  </div>
</app-page-content>
